import { fetchJobs } from "actions/jobs";
import RequireData from "hooks/RequireData";
import React from "react";
import { Link } from "react-router-dom";
import fetchJobsStatusSelector from "selectors/fetchJobsStatus";
import jobsSelector from "selectors/jobs";
import { statusTextForJob } from "utils/jobStatus";
import HomeCard from "./HomeCard";
import styles from "./JobsCard.module.scss";
import classnames from "classnames";

const JobsCard: React.FC = () => {
    const [jobs, status] = RequireData(
        jobsSelector,
        fetchJobsStatusSelector,
        fetchJobs()
    );

    const text = React.useMemo(() => {
        if (status === "error") {
            return "Error, reload to try again";
        } else if (status === "loading" || jobs === undefined) {
            return "Loading...";
        } else {
            if (jobs.length === 0) {
                return "No jobs yet, create your first!";
            } else {
                const job = jobs[0];
                return job.name || "Unnamed Job";
            }
        }
    }, [jobs, status]);

    const subtitle = React.useMemo(() => {
        if (
            status === "error" ||
            status === "loading" ||
            jobs === undefined ||
            jobs.length === 0
        ) {
            return null;
        }
        return statusTextForJob(jobs[0]);
    }, [status, jobs]);

    return (
        <HomeCard>
            <h5 className="card-title">Last Job</h5>
            <p className={classnames(styles.titleWithSubtitle)}>{text}</p>
            {subtitle && (
                <p>
                    <small>{subtitle}</small>
                </p>
            )}
            <Link to="/home/dashboard">View All Jobs</Link>
        </HomeCard>
    );
};

export default JobsCard;
